<template>
    <div class="card-item nodeCon" >
        <p class="flex-box al-c mb10" style="color: #024A84;">
            <img :src="`${baseUrl}images/${itemData.code}.png`" alt="">
            <span class="ml10 font-14" :style="{'font-size': type == 'index' ? '20px' : '14px'}">便签</span>
            <i class="el-icon-plus" style="padding-left: 10px" @click="addSc" v-if="type != 'index'"></i>
        </p>
        <div class="dateTop" :style="{'height': type == 'index' ? '180px' : '0'}">
            <!--左侧便签标题-->
            <div class="dateTop_left">
                <!--<el-input v-model="data.noteTitle" style="width: 100px" @focus="titleFocus"></el-input>-->
                <div class="topbtn" @click="inputShow" v-if="type != 'index'"></div>
                <div class="left_title" v-if="nodeTitleList.length > 0" :style="{'height': type == 'index' ? '100%' : '165px'}">
                    <p  v-for="(item,index) in nodeTitleList" :key="index"  @click="titleClick(item)" :style="{'background-color': item.color}">
                    </p>
                </div>
            </div>
            <!--右侧便签内容-->
            <div class="dateTop_right">
                <div class="colorSel" v-if="type != 'index'">
                    <span class="spanA"  @click="colorClick(item)" v-for="(item, index) in colorList" :key="index" :style="{'background-color': item.color}">
                        <span :class="modelColor == item.value ? 'spanS' : ''"></span>
                    </span>
                </div>
                <div  v-if="type != 'index'">
                    <el-input type="textarea" v-if="!textShow"   v-model="data.noteText" maxlength="50"  show-word-limit></el-input>
                </div>
                <div class="right_text" :style="{'background-color': showColor, 'height': type == 'index' ? '100%' : '0'}" v-if="textShow">
                    <p :style="{'height': type == 'index' ? '100%' : '147px'}">{{showText}}</p>
                    <div class="del" v-if="type != 'index'">
                        <i class="el-icon-delete"  @click="setDelNode"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getNodeList, setNode, delNode} from '@/api/management/showcase'
    export default {
        name: "Note",
        props:['itemData', 'type'],
        data(){
            return {
                baseUrl: process.env.BASE_URL,
                value: new Date(),
                data:{
                    noteText: ''
                },
                colorList: [
                    {
                        value: '#ffdf20',
                        color: '#ffdf20'
                    },
                    {
                        value: '#ff9634',
                        color: '#ff9634'
                    },
                    {
                        value: '#abff3d',
                        color: '#abff3d'
                    },
                    {
                        value: '#ff58c1',
                        color: '#ff58c1'
                    },
                    {
                        value: '#3aa4ff',
                        color: '#3aa4ff'
                    }

                ],
                modelColor: '#ffdf20',
                nodeTitleList: [],
                showColor: '#d0d0d0',
                textShow: false,
                showText: '',
                colorNum: '',
                num: 0
            }
        },
        mounted(){
            this.getNodeListData()
        },
        methods: {
            setDelNode(){
                delNode(this.nodeId || '').then(res =>{
                    if(res.data.code ==0 ){
                          this.getNodeListData()
                          this.textShow = false
                          this.showText = ''
                    }else {
                        this.$message.warning(res.msg)
                    }
                })
            },
            getNodeListData(){
                let params = {
                    len: 10000,
                    pos: 1
                }
                getNodeList(params).then(({data}) =>{
                    this.nodeTitleList = (data.data).reverse()
                    if(this.type == 'index') {
                        this.showColor = this.nodeTitleList[0].color
                        this.textShow =true
                    }
                })
            },
            colorClick(item){
                this.modelColor = item.value
            },
            inputShow(){
                this.textShow = false
            },
            titleClick(item){
                this.showColor = item.color
                this.textShow = true
                this.showText = item.content
                this.nodeId = item.id
            },
            // 添加标签
            addSc(){
                if(this.data.noteText != '') {
                    let params = {
                        color: this.modelColor || '',
                        content: this.data.noteText || '',
                        id: ''
                    }
                    setNode(params).then(res =>{
                        if(res.data.code == 0) {
                            this.getNodeListData()
                            this.data.noteText = ''
                        }else {
                            this.$message.warning(res.msg)
                        }
                    })
                }else {
                    this.$message.warning('请完善标签内容')
                }
            },
            // 删除标签
            delNote(){
                // this.textShow = false
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        },
    }
</script>

<style scoped lang="less">
    .nodeCon{
        height: 180px;
    }
    .nodeCon::-webkit-scrollbar {
        display: none;
    }
    .dateTop{
        display: flex;
        justify-content: flex-start;
        padding: 4px 0;
       .dateTop_left{
           padding: 0 3px;
           .topbtn{
               width: 100px;
               padding: 15px 10px;
               background-color: #d0d0d0;
           }
           .left_title{
               height: 165px;
               overflow-x: hidden;
               overflow-y: scroll;
               p{
                   width: 100px;
                   padding: 12px 10px;
                   /*background-color: #ffff00;*/
                   color: #333333;
                   margin: 2px 0;
               }
           }
           .left_title::-webkit-scrollbar {
               display: none;
           }

           }
       .dateTop_right{
            width: 100%;
            margin-left: 1px;
           .colorSel{
               display: flex;
               justify-content: flex-start;
               margin-bottom: 5px;
               span:nth-child(1) {
                   margin: 0px 3px 0 0;
               }
               span{
                   width: 20px;
                   height: 20px;
                   margin: 0 3px;
                   position: relative;
                   .spanS{
                       width: 0;
                       height: 0;
                       position: absolute;
                       left: 10px;
                       border-top: 10px solid #ff100e;
                       border-left: 10px solid transparent;
                   }
               }
           }
            .right_text{
                /*background-color: #767676;*/
                padding: 4px 10px;
                .del {
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
    }
</style>
<style>
    .el-calendar__body{
        padding: 6px 10px 20px 0;
    }
    .el-calendar-table .el-calendar-day {
        padding: 4px;
        height: 48px;
        font-size: 12px;
    }
   .dateTop_right .el-input .el-input__count{
        align-items: flex-end;
    }
    .dateTop_right .el-textarea .el-textarea__inner{
        min-height: 170px !important;
        max-height: 170px !important;
        background-color: #d0d0d0;
    }
</style>